import React, { useEffect, useState } from 'react';

const Banner = ({ campaign }) => {
    const { keyVisual1x1, keyVisual4x3 } = campaign || {};
    const mobileBreakpoint = '(max-width: 768px)';
    const [isMobile, setIsMobile] = useState(() => window.matchMedia(mobileBreakpoint).matches);

    useEffect(() => {
        const mediaQuery = window.matchMedia(mobileBreakpoint);
        const handleMediaQueryChange = (event) => {
            setIsMobile(event.matches);
        };

        // Set initial value
        setIsMobile(mediaQuery.matches);

        // Add listener
        mediaQuery.addEventListener('change', handleMediaQueryChange);

        // Clean up listener on unmount
        return () => {
            mediaQuery.removeEventListener('change', handleMediaQueryChange);
        };
    }, []);

    return (
        campaign && keyVisual1x1?.contentUrl && keyVisual4x3?.contentUrl && (
            <div className="banner-facet">
                <sbk-image facet={`${isMobile ? '2' : '5'}`} crop-mobile={`${!!isMobile}`}>
                    <img
                        data-title=""
                        data-publisher=""
                        data-source="SBK"
                        alt="Seitenbanner"
                        src={`${isMobile ? keyVisual4x3.contentUrl : keyVisual1x1.contentUrl}`}
                    />
                </sbk-image>
            </div>
        )
    );
};

export default Banner;
